import {
  compose,
  converge,
  prop,
  propOr,
} from 'ramda';
import { resolver } from '../util';
import { queryPingID, querySso, queryTokenExchange } from '../../models';

// Helpers

const unwrapPingID = propOr({}, 'fields');

const getUserId = compose(
  prop('user_id'),
  resolver.ctxProp('user'),
);

// Resolvers

const findPingID = resolver.compose(
  unwrapPingID,
  converge(queryPingID('findByAppKey'), [resolver.argProp('appKey'), getUserId]),
);

const upsertPingID = resolver.compose(
  unwrapPingID,
  converge(queryPingID('upsert'), [resolver.argProp('pingID'), getUserId]),
);

const findSso = resolver.compose(
  unwrapPingID,
  converge(querySso('findByAppKey'), [resolver.argProp('appKey'), getUserId]),
);

const upsertSso = resolver.compose(
  unwrapPingID,
  converge(querySso('upsert'), [resolver.argProp('sso'), getUserId]),
);

const findTokenExchange = resolver.compose(
  unwrapPingID,
  converge(queryTokenExchange('findByAppKey'), [resolver.argProp('appKey'), getUserId]),
);

const upsertTokenExchange = resolver.compose(
  unwrapPingID,
  converge(queryTokenExchange('upsert'), [resolver.argProp('tokenExchange'), getUserId]),
);

export default {
  Query: {
    pingID: findPingID,
    sso: findSso,
    tokenExchange: findTokenExchange,
  },
  Mutation: {
    pingID: upsertPingID,
    sso: upsertSso,
    tokenExchange: upsertTokenExchange,
  },
};
